var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartContractService(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 151.739,
    height: 158,
    viewBox: "0 0 151.739 158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-33.804 0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M110.049,143.181H39.128a5.325,5.325,0,0,1-5.318-5.32V31.7a2.46,2.46,0,0,1,.723-1.744L63.752.714A2.467,2.467,0,0,1,65.5-.01h73.4a5.326,5.326,0,0,1,5.32,5.32V72.855a2.468,2.468,0,0,1-2.469,2.469c-33.071,0-50.781,38.773-29.807,63.8a2.471,2.471,0,0,1-1.893,4.054ZM38.747,32.724V137.862a.393.393,0,0,0,.38.383h66.015c-18.436-28.063.468-65.909,34.136-67.787V5.312a.393.393,0,0,0-.382-.382H66.52L38.746,32.724Z",
    transform: "translate(-0.005)",
    fill: "#2979ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    d: "M62.64,34.157H36.274a2.473,2.473,0,0,1-1.746-4.215L63.744.724A2.473,2.473,0,0,1,67.959,2.47V28.838A5.325,5.325,0,0,1,62.64,34.157ZM42.233,29.22H62.64a.393.393,0,0,0,.382-.382V8.43Z",
    transform: "translate(0 -0.009)",
    fill: "#2979ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    d: "M348.661,428.327H279.535c-3.25,0-3.25-4.937,0-4.937h69.126C351.912,423.39,351.912,428.327,348.661,428.327Z",
    transform: "translate(-220.77 -384.202)",
    fill: "#2979ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    d: "M348.661,589.977H279.535c-3.25,0-3.25-4.937,0-4.937h69.126C351.912,585.04,351.912,589.977,348.661,589.977Z",
    transform: "translate(-220.77 -530.887)",
    fill: "#2979ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2050",
    "data-name": "Path 2050",
    d: "M320.879,751.637H279.545c-3.25,0-3.25-4.937,0-4.937h41.333C324.129,746.7,324.128,751.637,320.879,751.637Z",
    transform: "translate(-220.779 -677.581)",
    fill: "#2979ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2051",
    "data-name": "Path 2051",
    d: "M311.257,913.287H279.545c-3.25,0-3.25-4.937,0-4.937h31.712C314.507,908.35,314.507,913.287,311.257,913.287Z",
    transform: "translate(-220.779 -824.266)",
    fill: "#2979ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2052",
    "data-name": "Path 2052",
    d: "M311.257,1074.927H279.545c-3.25,0-3.25-4.937,0-4.937h31.712C314.507,1069.99,314.507,1074.927,311.257,1074.927Z",
    transform: "translate(-220.779 -970.942)",
    fill: "#2979ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2053",
    "data-name": "Path 2053",
    d: "M770.4,848.012a43.8,43.8,0,1,1,43.8-43.8A43.849,43.849,0,0,1,770.4,848.012Zm0-82.664a38.864,38.864,0,1,0,38.864,38.865A38.91,38.91,0,0,0,770.4,765.348Z",
    transform: "translate(-628.658 -690.022)",
    fill: "#2979ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2054",
    "data-name": "Path 2054",
    d: "M997.272,885.7a2.472,2.472,0,0,1-1.223-.324l-18.157-10.349a2.472,2.472,0,0,1-.916-3.379L995.134,840.2a2.471,2.471,0,0,1,4.276,0l18.157,31.449a2.471,2.471,0,0,1-.916,3.379l-18.157,10.349A2.463,2.463,0,0,1,997.272,885.7Zm-14.778-13.734,14.778,8.423,14.778-8.423-14.778-25.6Z",
    transform: "translate(-855.556 -761.304)",
    fill: "#2979ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2055",
    "data-name": "Path 2055",
    d: "M1015.56,1107.032l-18.156-7.592-17.181,7.39c-2.974,1.282-4.924-3.258-1.951-4.535l18.157-7.809a2.464,2.464,0,0,1,1.952,0l18.157,7.809a2.472,2.472,0,0,1-.978,4.737Z",
    transform: "translate(-855.688 -992.987)",
    fill: "#2979ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2056",
    "data-name": "Path 2056",
    d: "M1175.239,885.963a2.468,2.468,0,0,1-2.469-2.469V841.7c0-3.25,4.937-3.25,4.937,0v41.8a2.47,2.47,0,0,1-2.469,2.469Z",
    transform: "translate(-1033.523 -761.57)",
    fill: "#2979ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2057",
    "data-name": "Path 2057",
    d: "M996.351,1318.948a2.468,2.468,0,0,1-2.035-1.072l-18.24-26.6a2.473,2.473,0,0,1,3.261-3.54l17.065,9.76,17.011-9.758a2.473,2.473,0,0,1,3.262,3.541l-18.293,26.6A2.458,2.458,0,0,1,996.351,1318.948Zm-10.1-21.568,10.107,14.738,10.108-14.695-8.828,5.063a2.473,2.473,0,0,1-2.453,0Z",
    transform: "translate(-854.635 -1168.226)",
    fill: "#2979ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2058",
    "data-name": "Path 2058",
    d: "M1175.239,1421.909a2.468,2.468,0,0,1-2.469-2.469v-16.135c0-3.25,4.937-3.25,4.937,0v16.135a2.469,2.469,0,0,1-2.469,2.469Z",
    transform: "translate(-1033.523 -1271.187)",
    fill: "#2979ff",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartContractService);
export default __webpack_public_path__ + "static/media/smartContractService.6ba37305f3a2d1e22419926360cf063c.svg";
export { ForwardRef as ReactComponent };